module.exports = __webpack_public_path__ + "img/contentImg4.eae3375e.png";